import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { IdleTimeoutService } from '../../../services/idle-timeout.service';

/** The session-expiry warning. The root app component hosts it; IdleTimeoutService opens and closes it. */
@Component({
    selector: 'app-idle-timeout-dialog',
    templateUrl: './idle-timeout-dialog.component.html',
    standalone: true,
    imports: [NgIf, AsyncPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IdleTimeoutDialogComponent
{
    readonly open$ = this._idle.open$;
    readonly countdown$ = this._idle.countdown$;

    constructor(private _idle: IdleTimeoutService) {
    }

    signOut() {
        this._idle.close({keepAlive: false, preserveLocation: false});
    }

    staySignedIn() {
        this._idle.close({keepAlive: true, preserveLocation: false});
    }
}
